import { createContext, useContext } from "react";

const EmailAthletesContext = createContext({});
EmailAthletesContext.displayName = "EmailAthletes";

export const useEmailAthletes = () => useContext(EmailAthletesContext);
export const EmailAthletesProvider = EmailAthletesContext.Provider;

